import { Box, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import Routing from "./navigation/routing";
import "./App.css"

function App() {
  const theme = createTheme();
  return (
    <ThemeProvider theme={theme}>
      <Box className="body-background">
        <CssBaseline />
        <Routing />
      </Box>
    </ThemeProvider>
  );
}

export default App;
